import * as lookups from 'modules/api/lookups';
import { cancelFunctions } from 'utils/cancelFunctions';
import { CodeNameModel } from 'components/common/types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { FilterMultiDsps } from './FilterMultiDsp.types';

const FilterMultiDsp: React.FC<FilterMultiDsps> = ({ changeFilters, dsps, isDisabled }) => {
  const onLoadLookupData: AsyncSelectLoadDataHandler<CodeNameModel> = async (_, query) => {
    try {
      if (query.length < 2) {
        return [];
      }

      return await lookups.getDspLookupSuggestions(cancelFunctions, query);
    } catch (error) {
      return [];
    }
  };

  const onSelect: SelectHandler<CodeNameModel> = (_, value: CodeNameModel[]): void => {
    changeFilters({
      dsps: value,
    });
  };

  return (
    <AsyncSelect
      dataTestId="dsps-filter"
      name="dsps"
      loadData={onLoadLookupData}
      selectedValue={dsps}
      placeholder="DSP"
      onSelect={onSelect}
      multiple
      isDisabled={isDisabled}
    />
  );
};

export default FilterMultiDsp;
